import type { DialogueKwEvaluationMessage } from 'components/Dialogue/types';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import QuoteMessage from '../QuoteMessage';
import { useChatContext } from '../../contexts/ChatContext';
import { memo } from 'react';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { Rate } from 'antd';

export const KwEvaluationMsg = memo((props: BaseMsgProps) => {
  const { raw, msg, conversation } = props;
  const { t } = useTranslate();
  const { clickQuote } = useChatContext();
  const { score, labelContent } = (msg as DialogueKwEvaluationMessage).content;
  const { topBarInfo } = conversation;

  return (
    <MessageExtendComplex
      {...props}
      content={
        <QuoteMessage
          message={raw}
          storeName={topBarInfo?.storeName}
          wrap
          onQuoteClick={clickQuote}
        >
          <Container>
            <header>{score ? t('感谢您您的反馈') : t('您对本次的服务满意吗？')}</header>
            <Rate disabled value={score} />
            {score ? (
              <div style={score <= 3 ? { color: '#F05B5B' } : undefined}>
                {
                  {
                    1: t('很不满'),
                    2: t('不满意'),
                    3: t('一般'),
                    4: t('满意'),
                    5: t('很满意'),
                  }[score]
                }
              </div>
            ) : undefined}
            {score ? (
              labelContent ? (
                <section>
                  <span style={{ color: '#B5B9BF' }}>{t(labelContent)}</span>
                </section>
              ) : (
                <section>
                  {{
                    1: ['回复慢', '态度恶劣', '未解决问题', 'feedback.答非所问'],
                    2: ['回复慢', '态度恶劣', '未解决问题', 'feedback.答非所问'],
                    3: ['沟通体验一般', '卖家态度一般', '解决方案一般', '回复效率一般'],
                    4: ['沟通顺畅', '答案有帮助', '态度友好', '回复快'],
                    5: ['沟通顺畅', '答案有帮助', '态度友好', '回复快'],
                  }[score]?.map((label) => (
                    <span>{t(label)}</span>
                  ))}
                </section>
              )
            ) : null}
          </Container>
        </QuoteMessage>
      }
    />
  );
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 390px;
  max-width: 100%;
  padding: 12px;
  background: #fff;
  border-radius: 2px;
  > header {
    align-self: flex-start;
  }
  > ul {
    display: flex;
    justify-content: space-around;
    width: 100%;
    padding: 0 24px;
  }
  > div {
    margin: 10px 0;
    color: #84868c;
  }
  > section {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    > span {
      height: 24px;
      line-height: 22px;
      margin: 0 6px 6px;
      padding: 0 12px;
      border-radius: 12px;
      border: solid 1px #f0f2f5;
      color: #515359;
    }
  }
`;
